import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import {
  Child1dmbiwhmddqyq as Child,
  Companion_getInstance8cw09c4jvk3w as Companion_getInstance,
  IDjecfjjw6mot9 as ID,
  Family2k7vz7ddyergb as Family,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_lastNameeb1r6zhucrxq as get_lastName,
  get_firstName1l2zu2fsbg08t as get_firstName,
  get_birthDate38i0hzdi7d6gu as get_birthDate,
  get__id336i6k806byxy as get__id,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  allTextFieldsContain2y4ctgpgxc740 as allTextFieldsContain,
  textSearchConditionr2nfggw95qef as textSearchCondition,
  searchField2rc6mst1no9ok as searchField,
} from '../components/search.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { StringDeferringConfig2dp4ygunddfnv as StringDeferringConfig } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/StringDeferringConfig.mjs';
import { CsvFormat2d7d3ollhiney as CsvFormat } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvFormat.mjs';
import { ListSerializer1hxuk9dx5n9du as ListSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { download3e9i5zj8k9dp8 as download } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ChildDetailPage3f2al5z4lb3ic as ChildDetailPage } from './ChildDetailPage.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration28gf6ughsr3vf as toDuration,
  toDuration7gy6v749ektt as toDuration_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { debounce3vjzafx7e7d30 as debounce } from '../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  ChildFilters2g5230wjkae0g as ChildFilters,
  childFilters4elj5hqu45d5 as childFilters,
  childFilterChipsywe7tgy5yflx as childFilterChips,
} from './ChildFilters.mjs';
import { And1a3dbpwh0hxmu as And } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  first58ocm7j58k3q as first,
  toList3jhuyej2anx2q as toList,
  toSet2orjxp16sotqu as toSet,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  sortSelect2bs9xha2fqnl1 as sortSelect,
  exportButton1ekt3fxzrhh34 as exportButton,
} from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_1,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_atBottomStart1iulwjfo1udg3 as get_atBottomStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_1,
  tableRecycler8sos3tuo7qum as tableRecycler,
} from '../components/table.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function ChildrenListPage$SortOption$Companion$_anonymous__wxwikk() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.children.ChildrenListPage.SortOption', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(Child()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$4);
  this_0.ascending_ijynum_k$(get_lastName(it));
  this_0.ascending_ijynum_k$(get_firstName(it));
  var tmp$ret$0 = this_0.build_1k0s4u_k$();
  SortOption_NameAscending_instance = new (SortOption())('NameAscending', 0, 'Name, ascending', tmp$ret$0);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Child()), arrayOf([]), false));
  var tmp$ret$10 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$10);
  this_1.descending_tl4o2_k$(get_lastName(it_0));
  this_1.descending_tl4o2_k$(get_firstName(it_0));
  var tmp$ret$6 = this_1.build_1k0s4u_k$();
  SortOption_NameDescending_instance = new (SortOption())('NameDescending', 1, 'Name, descending', tmp$ret$6);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Child()), arrayOf([]), false));
  var tmp$ret$16 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$16);
  this_2.descending_tl4o2_k$(get_birthDate(it_1));
  var tmp$ret$12 = this_2.build_1k0s4u_k$();
  SortOption_YoungestFirst_instance = new (SortOption())('YoungestFirst', 2, 'Youngest first', tmp$ret$12);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_3 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Child()), arrayOf([]), false));
  var tmp$ret$22 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$22);
  this_3.ascending_ijynum_k$(get_birthDate(it_2));
  var tmp$ret$18 = this_3.build_1k0s4u_k$();
  SortOption_OldestFirst_instance = new (SortOption())('OldestFirst', 3, 'Oldest first', tmp$ret$18);
  if (Companion_instance_2 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var SortOption_NameAscending_instance;
var SortOption_NameDescending_instance;
var SortOption_YoungestFirst_instance;
var SortOption_OldestFirst_instance;
function values() {
  static_init();
  return [SortOption_NameAscending_getInstance(), SortOption_NameDescending_getInstance(), SortOption_YoungestFirst_getInstance(), SortOption_OldestFirst_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, ChildrenListPage$SortOption$Companion$_anonymous__wxwikk);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  static_init();
  return Companion_instance_2;
}
var $ENTRIES;
var SortOptionClass;
function SortOption() {
  if (SortOptionClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, sort) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.sort_1 = sort;
      }
    }
    initMetadataForClass($, 'SortOption', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    SortOptionClass = $;
  }
  return SortOptionClass;
}
function ChildrenListPage$_get_title_$lambda_xj30x6($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childrenListTitle_3nn3hu_k$();
}
function ChildrenListPage$condition$lambda$lambda(word) {
  return allTextFieldsContain(Companion_getInstance().serializer_9w0wvi_k$(), word);
}
function ChildrenListPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childrenListTitle_3nn3hu_k$();
}
function ChildrenListPage$render$lambda$lambda(it) {
  return it.displayName_1;
}
function ChildrenListPage$render$lambda$slambda(this$0, $this_exportButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = Companion_instance_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp_0 = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.condition_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var rows = yield* tmp.fetchAll_u3b0q4_k$(tmp_0, tmp$ret$1, $completion);
    var csv = (new (CsvFormat())(new (StringDeferringConfig())(EmptySerializersModule(), VOID, ''))).encodeToString_k0apqx_k$(ListSerializer(Companion_instance_3.serializer_9w0wvi_k$()), rows);
    yield* download($this_exportButton.get_context_h02k06_k$(), 'children.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function ChildrenListPage$render$lambda_0(it) {
  return new (ChildDetailPage())(it._id_1);
}
function ChildrenListPage$render$lambda_1($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childrenTableHeaderName_oazrcu_k$();
}
function ChildrenListPage$render$lambda_2($this$text, it) {
  return it.get_fullName_9skygt_k$();
}
function ChildrenListPage$render$lambda_3($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childrenTableHeaderFamily_fhtlt5_k$();
}
function ChildrenListPage$render$lambda_4($this$text, it) {
  var tmp0_safe_receiver = $this$text.invoke_r7m7el_k$($this$text.invoke_r7m7el_k$(get_currentSessionNotNull()).get_families_is4v1x_k$().get_6ueaa7_k$(new (ID())(it.family_1)));
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_familyName_6ytaaw_k$();
  return tmp1_elvis_lhs == null ? $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childUnknownLabel_wvpdgd_k$() : tmp1_elvis_lhs;
}
function ChildrenListPage$render$lambda_5($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childrenTableHeaderBirthdate_iu407u_k$();
}
function ChildrenListPage$render$lambda_6($this$text, it) {
  return renderToString(it.birthDate_1);
}
function ChildrenListPage$render$lambda_7($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
function SortOption_NameAscending_getInstance() {
  static_init();
  return SortOption_NameAscending_instance;
}
function SortOption_NameDescending_getInstance() {
  static_init();
  return SortOption_NameDescending_instance;
}
function SortOption_YoungestFirst_getInstance() {
  static_init();
  return SortOption_YoungestFirst_instance;
}
function SortOption_OldestFirst_getInstance() {
  static_init();
  return SortOption_OldestFirst_instance;
}
var ChildrenListPageClass;
function ChildrenListPage() {
  if (ChildrenListPageClass === VOID) {
    class $ {
      constructor() {
        this.textSearch_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_0();
        var tmp$ret$0 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
        tmp.debouncedTextSearch_1 = debounce(this.textSearch_1, tmp$ret$0, get_AppScope());
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (ChildFilters())());
        var tmp_0 = this;
        tmp_0.condition_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(this.debouncedTextSearch_1);
          return And().new_com_lightningkite_services_database_Condition_And_ln02sz_k$([textSearchCondition(tmp, ChildrenListPage$condition$lambda$lambda), $this$remember.invoke_r7m7el_k$(this.filter_1).toCondition_oj74tc_k$()]);
        });
        this.sort_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(first(get_entries()));
        var tmp_1 = this;
        tmp_1.data_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_children_4cwbp4_k$();
          var tmp_0 = new (Query())($this$remember.invoke_r7m7el_k$(this.condition_1), $this$remember.invoke_r7m7el_k$(this.sort_1).sort_1, VOID, 50);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$1 = toDuration_0(5, DurationUnit_MINUTES_getInstance());
          return tmp.list$default_sjz00l_k$(tmp_0, VOID, tmp$ret$1);
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ChildrenListPage$_get_title_$lambda_xj30x6);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_1().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_2.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = get_atBottomStart(element_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ChildrenListPage$render$lambda);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_4 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        searchField(element_0, this.textSearch_1);
        sortSelect(element_0, ($this$sortSelect) => {
          var tmp = _Constant___init__impl__v45mub(toList(get_entries()));
          $this$sortSelect.bind_64a41i_k$(this.sort_1, new (Constant())(tmp), ChildrenListPage$render$lambda$lambda);
          return Unit_instance;
        });
        childFilters(element_0, this.filter_1);
        exportButton(element_0, ($this$exportButton) => {
          $this$exportButton.set_action_2ds022_k$(Action('Export children', VOID, VOID, VOID, VOID, VOID, ChildrenListPage$render$lambda$slambda(this, $this$exportButton)));
          return Unit_instance;
        });
        element_0.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_0);
        childFilterChips(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_2 = weight(element, 1.0);
        var tmp_3 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.data_1));
        var tmp_4 = ChildrenListPage$render$lambda_0;
        var tmp_5 = Companion_instance_1;
        var tmp_6 = ChildrenListPage$render$lambda_1;
        var tmp_7 = tmp_5.text$default_gwb2zv_k$(tmp_6, VOID, ChildrenListPage$render$lambda_2);
        var tmp_8 = Companion_instance_1;
        var tmp_9 = ChildrenListPage$render$lambda_3;
        var tmp_10 = tmp_8.text$default_gwb2zv_k$(tmp_9, VOID, ChildrenListPage$render$lambda_4);
        var tmp_11 = Companion_instance_1;
        var tmp_12 = ChildrenListPage$render$lambda_5;
        tableRecycler(tmp_2, tmp_3, tmp_4, [tmp_7, tmp_10, tmp_11.text$default_gwb2zv_k$(tmp_12, VOID, ChildrenListPage$render$lambda_6)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_5 = shownWhen(element, VOID, VOID, ChildrenListPage$render$lambda_7);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Space())(this_5.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'ChildrenListPage', ChildrenListPage, VOID, [Page()]);
    ChildrenListPageClass = $;
  }
  return ChildrenListPageClass;
}
function ChildCsvRow$Companion$fetchAll$lambda(it) {
  return it.displayName_1;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      *fetchAll_u3b0q4_k$(api, condition, $completion) {
        var children = yield* api.get_child_ipppmb_k$().query_o986pg_k$(new (Query())(condition, VOID, VOID, 2147483647), $completion);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(children, 10));
        var _iterator__ex2g4s = children.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = new (ID())(item.family_1);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        var familyIds = toSet(destination);
        var tmp = api.get_family_d7lffx_k$();
        var tmp2 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_0 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
        var tmp$ret$6 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$6);
        var tmp$ret$7 = xDataClassPathInsideSet(get__id(it), familyIds);
        var tmp$ret$3 = new (Query())(tmp$ret$7, orderBy, 0, tmp2);
        // Inline function 'kotlin.collections.associate' call
        var this_0 = yield* tmp.query_o986pg_k$(tmp$ret$3, $completion);
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = to(new (ID())(element._id_1), element.get_familyName_6ytaaw_k$());
          destination_0.put_4fpzoq_k$(pair.first_1, pair.second_1);
        }
        var familyNames = destination_0;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(children, 10));
        var _iterator__ex2g4s_1 = children.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp0_elvis_lhs = familyNames.get_wei43m_k$(new (ID())(item_0.family_1));
          var tmp_1 = tmp0_elvis_lhs == null ? 'NOT FOUND' : tmp0_elvis_lhs;
          var tmp_2 = item_0.get_ageInMonths_kafbji_k$();
          var tmp$ret$14 = new (ChildCsvRow())(item_0.firstName_1, item_0.lastName_1, tmp_1, item_0.birthDate_1, tmp_2, joinToString(item_0.race_1, '; ', VOID, VOID, VOID, VOID, ChildCsvRow$Companion$fetchAll$lambda), item_0.active_1);
          destination_1.add_utx5q5_k$(tmp$ret$14);
        }
        return destination_1;
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($, VOID, VOID, [2]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.children.ChildCsvRow', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('firstName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('lastName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('family', false);
        tmp0_serialDesc.addElement_5pzumi_k$('birthDate', false);
        tmp0_serialDesc.addElement_5pzumi_k$('ageInMonths', false);
        tmp0_serialDesc.addElement_5pzumi_k$('race', false);
        tmp0_serialDesc.addElement_5pzumi_k$('active', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_5zlcza_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.firstName_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.lastName_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.family_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), value.birthDate_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 4, value.ageInMonths_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 5, value.race_1);
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 6, value.active_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_5zlcza_k$(encoder, value instanceof ChildCsvRow() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = 0;
        var tmp9_local5 = null;
        var tmp10_local6 = false;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeIntElement_941u6a_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, LocalDateSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeIntElement_941u6a_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ChildCsvRow().new_org_thecommunitygroupinc_cares_views_children_ChildCsvRow_hn82b8_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LocalDateSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ChildCsvRowClass;
function ChildCsvRow() {
  if (ChildCsvRowClass === VOID) {
    class $ {
      constructor(firstName, lastName, family, birthDate, ageInMonths, race, active) {
        this.firstName_1 = firstName;
        this.lastName_1 = lastName;
        this.family_1 = family;
        this.birthDate_1 = birthDate;
        this.ageInMonths_1 = ageInMonths;
        this.race_1 = race;
        this.active_1 = active;
      }
      toString() {
        return 'ChildCsvRow(firstName=' + this.firstName_1 + ', lastName=' + this.lastName_1 + ', family=' + this.family_1 + ', birthDate=' + this.birthDate_1.toString() + ', ageInMonths=' + this.ageInMonths_1 + ', race=' + this.race_1 + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.firstName_1);
        result = imul(result, 31) + getStringHashCode(this.lastName_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.family_1) | 0;
        result = imul(result, 31) + this.birthDate_1.hashCode() | 0;
        result = imul(result, 31) + this.ageInMonths_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.race_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChildCsvRow()))
          return false;
        if (!(this.firstName_1 === other.firstName_1))
          return false;
        if (!(this.lastName_1 === other.lastName_1))
          return false;
        if (!(this.family_1 === other.family_1))
          return false;
        if (!this.birthDate_1.equals(other.birthDate_1))
          return false;
        if (!(this.ageInMonths_1 === other.ageInMonths_1))
          return false;
        if (!(this.race_1 === other.race_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_children_ChildCsvRow_hn82b8_k$(seen0, firstName, lastName, family, birthDate, ageInMonths, race, active, serializationConstructorMarker) {
        if (!(127 === (127 & seen0))) {
          throwMissingFieldException(seen0, 127, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.firstName_1 = firstName;
        $this.lastName_1 = lastName;
        $this.family_1 = family;
        $this.birthDate_1 = birthDate;
        $this.ageInMonths_1 = ageInMonths;
        $this.race_1 = race;
        $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'ChildCsvRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    ChildCsvRowClass = $;
  }
  return ChildCsvRowClass;
}
//region block: init
Companion_instance_3 = new (Companion_0())();
//endregion
//region block: exports
export {
  SortOption as SortOption2cy91nan8ja9,
  ChildrenListPage as ChildrenListPage2q8x8yakd8gse,
};
//endregion

//# sourceMappingURL=ChildrenListPage.mjs.map
